
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.591 3.58a.5.5 0 01.818 0l1.098 1.559a.5.5 0 00.619.166l1.73-.801a.5.5 0 01.708.409l.171 1.899a.5.5 0 00.453.453l1.9.171a.5.5 0 01.408.708l-.8 1.73a.5.5 0 00.165.62l1.559 1.097a.5.5 0 010 .818l-1.559 1.098a.5.5 0 00-.166.619l.801 1.73a.5.5 0 01-.409.708l-1.899.171a.5.5 0 00-.453.453l-.171 1.9a.5.5 0 01-.708.408l-1.73-.8a.5.5 0 00-.62.165L12.41 20.42a.5.5 0 01-.818 0l-1.098-1.559a.5.5 0 00-.619-.166l-1.73.801a.5.5 0 01-.708-.409l-.171-1.899a.5.5 0 00-.453-.453l-1.9-.171a.5.5 0 01-.408-.708l.8-1.73a.5.5 0 00-.165-.62L3.58 12.41a.5.5 0 010-.818l1.559-1.098a.5.5 0 00.166-.619l-.801-1.73a.5.5 0 01.409-.708l1.899-.171a.5.5 0 00.453-.453l.171-1.9a.5.5 0 01.708-.408l1.73.8a.5.5 0 00.62-.165L11.59 3.58z","fill":"#303030"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"5.5","fill":"#202020"}}),_c('path',{attrs:{"d":"M12.136 6.502a5.34 5.34 0 00-1.583.193c-.258.071-.31.42-.08.554A5.513 5.513 0 0113.196 12a5.513 5.513 0 01-2.723 4.751c-.23.134-.179.483.08.554.456.127.935.195 1.43.195 3.01-.006 5.527-2.444 5.5-5.539-.028-3.094-2.437-5.37-5.347-5.459z","fill":"url(#paint55_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint55_linear","x1":"13","y1":"6","x2":"18.627","y2":"15.253","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#C1C6D0"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#5A5D62"}})])])])
          )
        }
      }
    